import { Component, OnInit, OnDestroy } from '@angular/core';
import { Brand } from '../../shared/models/brand';
import { BrandService } from '../../shared/services/brand.service';
import { ActivatedRoute } from '@angular/router';
import { STATES, State } from '../../shared/models/state';
import { FormBuilder, FormGroup, Validators} from '@angular/forms'; 
import { MatSnackBar } from '@angular/material/snack-bar'; 
import { formatDate } from '@angular/common';
import { SpinnerService } from '../../shared/components/spinner/spinner.service';
import { TemplateService } from '../../shared/services/template.service';
import { Template } from '../../shared/models/Template';
import { ValidationService } from '../../shared/services/validation.service';
 
@Component({
  selector: 'app-brand-details',
  templateUrl: './brand-details.component.html'
})

export class BrandDetailsComponent implements OnInit, OnDestroy {
  public brand: Brand;
  public subbrands: Brand[];
  public templates: Template[];
  public msg: string;
  private id: number;
  private sub: any;
  public stateList: State[]; 
  public parentBrands: Brand[];   
  editBrandForm: FormGroup;
  editBrandFormSubmitted = false;
  readonly DELIMITER = '-'

  constructor(
    private brandService: BrandService,
    private templateService: TemplateService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private notification: MatSnackBar,
    private spinnerService: SpinnerService) { }

  ngOnInit() {
    // show spinner on page load
    this.spinnerService.show();

    this.sub = this.route.params.subscribe(params => {
      this.id = +params['id']; // (+) converts string 'id' to a number  
      this.msg = '';

      // get brand profile
      this.brandService.getById(this.id).subscribe(result => {

        this.templateService.getAll().subscribe(templateResult => {
          if (templateResult.length) {
            this.templates = templateResult;
          }
        }, error => console.error(error));

        this.brandService.getAllMaster().subscribe(masterResult => {
          if (masterResult.length) {
            // used for profile parent brand field select
            this.parentBrands = masterResult;
          }
          // this.brands = result;
        }, error => console.error(error));

        // bind list of states
        this.stateList = STATES;

        this.brand = result; 
        
        // initialize edit brand form
        this.editBrandForm = this.formBuilder.group({
          name: [this.brand.name, Validators.required],
          firstName: [this.brand.firstName || ''],
          lastName: [this.brand.lastName || ''],
          address1: [this.brand.address1 || ''],
          address2: [this.brand.address2 || ''],
          city: [this.brand.city || '', ValidationService.alphaNumericSpecialCharactersValidator],
          state: [this.brand.state || ''],
          zipCode: [this.brand.zipCode || '', ValidationService.zipCodeValidator],
          email: [this.brand.email || '', Validators.email],
          phone: [this.brand.phone || '', ValidationService.phoneValidator],
          url: [this.brand.url || '', ValidationService.urlValidator],
          startDate: [this.brand.startDate || '', Validators.required],
          management: [this.brand.management || ''],
          brandId: [this.brand.brandId || 0, Validators.required],
          templateId: [this.brand.templateId || 0, Validators.required],
          isActive: [this.brand.isActive || false]
        });

        // hide spinner
        setTimeout(() => {
          this.spinnerService.hide();
        }, 1500); 

      }, error => console.error(error));
      
    });  
  }

  // format date
  formatDate(e, fieldName: string) {
    if (e.target.value === null) {
      this.editBrandForm.get(fieldName).setValue('', {
        onlyself: true
      })
    }
    else { 
      var convertDate = new Date(e.target.value);
        
      this.editBrandForm.get(fieldName).setValue(convertDate, {
        onlyself: true
      })
    }
  }

  // update existing brand details
  updateBrand() { 
    this.editBrandFormSubmitted = true;

    // stop here if form is invalid
    if (this.editBrandForm.invalid) {
      return;
    } 

    //var startDate = formatDate(this.editBrandForm.value["startDate"], 'MM-dd-yyyy', 'en-US'); 
    this.brand.name = this.editBrandForm.value["name"];
    this.brand.firstName = this.editBrandForm.value["firstName"];
    this.brand.lastName = this.editBrandForm.value["lastName"];
    this.brand.brandId = +this.editBrandForm.value["brandId"];
    this.brand.templateId = +this.editBrandForm.value["templateId"];
    this.brand.address1 = this.editBrandForm.value["address1"];
    this.brand.address2 = this.editBrandForm.value["address2"];
    this.brand.city = this.editBrandForm.value["city"];
    this.brand.state = this.editBrandForm.value["state"];
    this.brand.zipCode = this.editBrandForm.value["zipCode"];
    this.brand.management = this.editBrandForm.value["management"];
    this.brand.phone = this.editBrandForm.value["phone"];
    this.brand.email = this.editBrandForm.value["email"];
    this.brand.url = this.editBrandForm.value["url"];
    this.brand.startDate = formatDate(this.editBrandForm.value["startDate"], 'yyyy-MM-dd', 'en-US'); //this.formatNgDate(this.editBrandForm.value["startDate"]);
    this.brand.isActive = this.editBrandForm.value["isActive"];

    this.brandService.update(this.id, this.brand)
      .subscribe(() =>
        // Simple message with an action.
        this.showNotification('Your changes have been saved!', 'Okay!')
    );

  } 
 
  // destroy 
  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  // display notifications
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
  }
} 
